export enum UserBlockType {
    NotBlocked = 0,
    Charging = 10,
}

export enum ExternalUserType {
    EverestSupervisor = '10',
    EverestDriver = '20',
    EverestGuard = '30',
    Everest3WDriver = '40',
    EverestCngDriver = '50',
    EverestCngPumpAttendant = '60',
}

/**
 * Defines the source from where a particular user was added
 */
export enum UserSource {
    CPO = 'cpo',
    Everest = 'everest',
}

export enum SignUpSource {
    InstaOnboarding = '10',
}

export enum DriverType {
    MBG = 'MBG',
    LEASING = 'Leasing',
}

export enum UserAllotmentStatus {
    ALLOTTED = 'ALLOTTED',
    CHECKED_IN = 'CHECKED_IN',
}

export enum LoginOTPSource {
    Whatsapp = 'whatsapp',
    Kaleyra = 'kaleyra',
    Sparrow = 'sparrow',
}

// These (UserAttributeKey, UserAttributeValue, UserAttribute) are only to be used in the backend. Refrain from using in the frontend /*

export enum UserAttributeKey {
    VehicleOwnerOEMs = 'VehicleOwnerOEMs',
    VehicleOwnerModel = 'VehicleOwnerModel',
}

export enum UserAttributeValue {
    MG = 'MG',
    WindsorEV = 'WindsorEV',
}

/**
 * @NOTE Keep Key value of the enum same for ElectricVehicleName
 * or change UserVehicleType to use the value
 */

export enum ElectricVehicleName {
    windsor_ev = 'windsor_ev',
    etron = 'etron',
}

/**
 * @NOTE Ensure `UserAttributeKey` and `UserAttributeValue` have the same values
 */
export enum UserAttribute {
    'VehicleOwnerOEMs:MG' = 'VehicleOwnerOEMs:MG',
    'VehicleOwnerModel:WindsorEV' = 'VehicleOwnerModel:WindsorEV',
}

// These (UserAttributeKey, UserAttributeValue, UserAttribute) are only to be used in the backend. Refrain from using in the frontend */

export enum UserLogoutReason {
    Other = 'Other',
    NumberChanged = 'Number Changed',
}

export enum MgFreeDiscountsSheetInfo {
    TotalBalance = 'total_balance',
    RemainingBalance = 'remaining_balance',
    LastUpdated = 'last_updated',
    CarNumber = 'car_number',
    OwnerName = 'owner_name',
    PhoneNumber = 'phone_number',
    LastUpdatedInDb = 'last_update_in_db',
}

export enum DiscountsEnum {
    MGFREE = 'MGFREE'
}